import { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import { Image } from 'react-bootstrap';
import Marquee from "react-fast-marquee";
export default function StickyNotice() 
{
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    const[stickynotice,setNotices]=useState([])
    useEffect(()=>
    {
        if( stickynotice.length === 0 )
        {
            getStickyNotice()
        }  
    },[stickynotice])
    const getStickyNotice = async () => 
    {
        try 
        {
            const response = await fetch(global.config.API_URL+"notices/sticky");
            if (response.ok) 
            {
                const result = await response.json();
                setNotices(result);
                if( global.config.IsPrint === true )
                {
                    console.info('Sticky Notice : Result',result);
                }
            }
        }
        catch (error) 
        {
            console.error('Sticky Notice : Error', error.message);
        }
    };
    return (
        <div className="sticky-notice">
            <Marquee behavior='scroll' direction="left" pauseOnHover='true' >
                {stickynotice.map((sn,index)=>(
                    <Link to={appLanguage === 'hi' ? `/नोटिस/विवरण/${sn.sn_htaccess_hi || sn.sn_htaccess}` : `/notice/details/${sn.sn_htaccess}`} target='_blank' rel="noreferrer" key={index} aria-label={ appLanguage === 'hi' ? sn.sn_name_hi || sn.sn_name : sn.sn_name }>
                        <Image src={global.config.uploadPath+'627254849.png'} fluid className='me-2' width={32} height={32} alt={'New Notice #'+sn.sn_id} loading="lazy" />
                        {appLanguage === 'hi' ? sn.sn_name_hi || sn.sn_name : sn.sn_name}
                    </Link>
                ))}
            </Marquee>
        </div>   
    );
  }